export const SET_CSRF_TOKEN = "SET_CSRF_TOKEN";
export const REQUEST_CSRF_TOKEN = "REQUEST_CSRF_TOKEN";
export const SET_SESSION_STATUS = "SET_SESSION_STATUS";